import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/permission'
import '@/utils/flexible'
import '@/styles/index.scss'

// 全局注册
import '@/components/toast/index.css'
import cToast from '@/components/toast/index'
Vue.use(cToast)
Vue.config.productionTip = false

let vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vue